import { render } from "./ChangeCurrencyModal.vue?vue&type=template&id=a8e00fb4&ts=true"
import script from "./ChangeCurrencyModal.vue?vue&type=script&lang=ts"
export * from "./ChangeCurrencyModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__